import PropTypes from "prop-types";
import React from "react";
import { injectIntl, intlShape } from "react-intl";
import { Link } from "react-router-dom";
import messages from "components/messagesDescription";
import * as widgetTypes from "./WidgetTypes";
import { intlFormat } from "i18n/util";
import { Button } from "cxa-components";
import ReactTelInput from "react-telephone-input/lib/withStyles";

const isNotificationVisible = (notifications, type) => {
  const notification = notifications.find(notification => notification.id === type);
  return (notification && notification.notify) || false;
};

const NotificationDownloadCard = ({ notifications, sendSms, updatePhoneNumber, intl }) => {
  if (!isNotificationVisible(notifications, widgetTypes.NOTIFICATION_DOWNLOAD_CARD)) {
    return null;
  }

  const companyName = intlFormat(intl, messages.companyDescription);
  const linkProviderName = intlFormat(intl, messages.appLinkProviderDescription);
  return (
    <article key={"DownloadAppCard"} className="card">
      <header>
        <h2>{intlFormat(intl, messages.sendCxaAppDownloadLinkDescription)}</h2>
      </header>
      <section>
        <div className="cxa-grid__wrapper">
          <div className="cxa-grid__item cxa-grid__item--four">
            <img src="/assets/images/cxa-app.png" alt="download app" />
          </div>
          <div className="cxa-grid__item cxa-grid__item--eight">
            <div>
              <form className="apl-sms-app">
                <div className="field">
                  <p>{intlFormat(intl, messages.dashboard.downloadApp.enterMobileNumber)}</p>
                  <ReactTelInput
                    defaultCountry="sg"
                    preferredCountries={["sg", "hk"]}
                    flagsImagePath="/assets/images/flags.png"
                    onChange={updatePhoneNumber}
                  />
                </div>
                <Button primary type="button" onClick={() => sendSms()}>
                  Submit
                </Button>
              </form>
              <p>
                {intlFormat(intl, messages.mobileAppinfoDescription, {
                  companyName,
                  linkProviderName,
                })}
              </p>
              <p>
                <a
                  href="https://branch.io/privacy_policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {intlFormat(intl, messages.appLinkProviderLinDescription, {
                    providerName: linkProviderName,
                  })}
                </a>
              </p>
            </div>
            <p className="apl-app-links">
              <a href="https://appsto.re/sg/5tQN-.i" target="_blank" rel="noopener noreferrer">
                <img src="/assets/images/app-store.png" alt="app store" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.cxagroup.cxa"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/images/google-play.png" alt="google play store" />
              </a>
            </p>
          </div>
        </div>
      </section>
    </article>
  );
};

NotificationDownloadCard.propTypes = {
  intl: intlShape.isRequired,
  notifications: PropTypes.array.isRequired,
  sendSms: PropTypes.func,
  updatePhoneNumber: PropTypes.func,
};

export default injectIntl(NotificationDownloadCard);



// WEBPACK FOOTER //
// ./components/dashboard/widgets/NotificationDownloadCard.js